import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { INTEGRATION_ASSET_RESULTS } from './schema';

const QUERY = gql`
  query IntegrationAssetsResults(
    $customerId: ID!
    $accountId: ID
    $dataSource: PerformanceCenterDataSource
    $statuses: [IntegrationAssetStatus!]
  ) {
    integrationAssets(
      customerId: $customerId
      dataSource: $dataSource
      accountId: $accountId
      statuses: $statuses
    ) {
      ...IntegrationAssetResults
    }
  }
  ${INTEGRATION_ASSET_RESULTS}
`;

export const queryIntegrationAssetResults = (
  { customerId, dataSource, accountId, statuses },
  options = null
) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      dataSource,
      accountId,
      statuses,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  }).then(({ data }) => getSingleProp(data));
};
